export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "de": {
        "size": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Größe"])},
        "color": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Farbe"])},
        "price-category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Betreungsdauer"])}
      },
      "en": {
        "size": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Size"])},
        "color": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Color"])},
        "price-category": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Caretaking time"])}
      }
    }
  })
}